define("shared/components/shared/post/secondary/activity/footer", ["exports", "@ember/component", "ember-concurrency/async-arrow-runtime", "@ember/object", "@ember/service", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "ember-concurrency", "lodash", "later/utils/constants/segment-events", "later/utils/is-emoji-only", "@ember/template-factory"], function (_exports, _component, _asyncArrowRuntime, _object, _service, _utils, _component2, _tracking, _emberConcurrency, _lodash, _segmentEvents, _isEmojiOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _maxCharacters;
  0; //eaimeta@70e063a35619d71f0,"ember-concurrency/async-arrow-runtime",0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"ember-concurrency",0,"lodash",0,"later/utils/constants/segment-events",0,"later/utils/is-emoji-only",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
  function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
  function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
  function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateFieldGet(receiver, privateMap) { var descriptor = _classPrivateFieldGet2(privateMap, receiver); return _classApplyDescriptorGet(receiver, descriptor); }
  function _classPrivateFieldGet2(s, a) { return s.get(_assertClassBrand(s, a)); }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _classApplyDescriptorGet(receiver, descriptor) { if (descriptor.get) { return descriptor.get.call(receiver); } return descriptor.value; }
  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  {{#if this.canUsePostActivityLog}}
    <div
      class="o--modalFooter cAP--modalFooter"
      data-test-id="post-activity-footer"
      {{did-insert (toggle-action "autoFocus" this)}}
    >
      <hr class="u--m__t__0 u--m__b" />
      <div class="cAP--textarea">
        {{! Header }}
        <div class="cAP--textarea__header">
          <span class="u--text--sm u--ellipsis u--m__r__sm qa--activity_modal_comment_title">
            {{#if this.needsUsernameUpdate}}
              <EmberPopover>
                {{t "approval.secondary-modal.footer.needs_username_1"}}
                <LinkToExternal @route="account" class="u--text--bold" onClick={{this.trackPopoverClicked}}>
                  {{t "shared_phrases.click_here"}}
                </LinkToExternal>
                {{t "approval.secondary-modal.footer.needs_username_2"}}
              </EmberPopover>
            {{/if}}
            {{html-safe (t "approval.secondary-modal.footer.commenting_as" username=this.username)}}
          </span>
          <Shared::Ui::Button
            @class="qa--activity_modal_comment_saveBtn"
            @isDisabled={{this.isDisabled}}
            @promise={{this.saveComment}}
            @size="small"
            @text={{t "shared_words.save"}}
            @variant="primary"
            data-test-id="post-activity-footer-save"
          />
        </div>
  
        {{! Textarea }}
        <Shared::EmojiTextarea
          @autofocus={{true}}
          @buttonClass="qa--activity_modal_comment_emoji"
          @displayText={{t "shared_words.emoji"}}
          @isDisabled={{false}}
          @name="activityComment"
          @placeholder={{t "approval.secondary-modal.footer.placeholder"}}
          @value={{this.commentContent}}
          class={{concat-classes
            "cAP--textarea__input qa--activity_modal_textarea"
            (if this.showLargeText "u--text--lg")
          }}
          data-test-id="post-activity-footer-textarea"
          {{on "keyup" this.onKeyUp}}
        />
  
        {{! Emoji | Characters left}}
        <div class="cAP--textarea__footer">
          <div class="cAP--textarea__divider"></div>
          <span
            class={{concat-classes "u--text--sm" (if this.exceededCharacterLimit "u--text--danger" "u--text--light")}}
          >
  
            {{t "approval.secondary-modal.footer.characters_left" count=this.charactersRemaining}}
          </span>
        </div>
      </div>
    </div>
  {{else}}
    <div class="o--modalFooter cAP--modalFooter cAP--modalFooter--upgrade">
      <Shared::Ui::Button
        @additional="block"
        @onClick={{@toggleActivityModal}}
        @text={{t "shared_words.close"}}
        @variant="outline"
      />
    </div>
  {{/if}}
  */
  {
    "id": "Ldemcoug",
    "block": "[[[41,[30,0,[\"canUsePostActivityLog\"]],[[[1,\"  \"],[11,0],[24,0,\"o--modalFooter cAP--modalFooter\"],[24,\"data-test-id\",\"post-activity-footer\"],[4,[38,1],[[28,[37,2],[\"autoFocus\",[30,0]],null]],null],[12],[1,\"\\n    \"],[10,\"hr\"],[14,0,\"u--m__t__0 u--m__b\"],[12],[13],[1,\"\\n    \"],[10,0],[14,0,\"cAP--textarea\"],[12],[1,\"\\n\"],[1,\"      \"],[10,0],[14,0,\"cAP--textarea__header\"],[12],[1,\"\\n        \"],[10,1],[14,0,\"u--text--sm u--ellipsis u--m__r__sm qa--activity_modal_comment_title\"],[12],[1,\"\\n\"],[41,[30,0,[\"needsUsernameUpdate\"]],[[[1,\"            \"],[8,[39,3],null,null,[[\"default\"],[[[[1,\"\\n              \"],[1,[28,[35,4],[\"approval.secondary-modal.footer.needs_username_1\"],null]],[1,\"\\n              \"],[8,[39,5],[[24,0,\"u--text--bold\"],[16,\"onClick\",[30,0,[\"trackPopoverClicked\"]]]],[[\"@route\"],[\"account\"]],[[\"default\"],[[[[1,\"\\n                \"],[1,[28,[35,4],[\"shared_phrases.click_here\"],null]],[1,\"\\n              \"]],[]]]]],[1,\"\\n              \"],[1,[28,[35,4],[\"approval.secondary-modal.footer.needs_username_2\"],null]],[1,\"\\n            \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"          \"],[1,[28,[35,6],[[28,[37,4],[\"approval.secondary-modal.footer.commenting_as\"],[[\"username\"],[[30,0,[\"username\"]]]]]],null]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[8,[39,7],[[24,\"data-test-id\",\"post-activity-footer-save\"]],[[\"@class\",\"@isDisabled\",\"@promise\",\"@size\",\"@text\",\"@variant\"],[\"qa--activity_modal_comment_saveBtn\",[30,0,[\"isDisabled\"]],[30,0,[\"saveComment\"]],\"small\",[28,[37,4],[\"shared_words.save\"],null],\"primary\"]],null],[1,\"\\n      \"],[13],[1,\"\\n\\n\"],[1,\"      \"],[8,[39,8],[[16,0,[28,[37,9],[\"cAP--textarea__input qa--activity_modal_textarea\",[52,[30,0,[\"showLargeText\"]],\"u--text--lg\"]],null]],[24,\"data-test-id\",\"post-activity-footer-textarea\"],[4,[38,10],[\"keyup\",[30,0,[\"onKeyUp\"]]],null]],[[\"@autofocus\",\"@buttonClass\",\"@displayText\",\"@isDisabled\",\"@name\",\"@placeholder\",\"@value\"],[true,\"qa--activity_modal_comment_emoji\",[28,[37,4],[\"shared_words.emoji\"],null],false,\"activityComment\",[28,[37,4],[\"approval.secondary-modal.footer.placeholder\"],null],[30,0,[\"commentContent\"]]]],null],[1,\"\\n\\n\"],[1,\"      \"],[10,0],[14,0,\"cAP--textarea__footer\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"cAP--textarea__divider\"],[12],[13],[1,\"\\n        \"],[10,1],[15,0,[28,[37,9],[\"u--text--sm\",[52,[30,0,[\"exceededCharacterLimit\"]],\"u--text--danger\",\"u--text--light\"]],null]],[12],[1,\"\\n\\n          \"],[1,[28,[35,4],[\"approval.secondary-modal.footer.characters_left\"],[[\"count\"],[[30,0,[\"charactersRemaining\"]]]]]],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],[[[1,\"  \"],[10,0],[14,0,\"o--modalFooter cAP--modalFooter cAP--modalFooter--upgrade\"],[12],[1,\"\\n    \"],[8,[39,7],null,[[\"@additional\",\"@onClick\",\"@text\",\"@variant\"],[\"block\",[30,1],[28,[37,4],[\"shared_words.close\"],null],\"outline\"]],null],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]]]],[\"@toggleActivityModal\"],false,[\"if\",\"did-insert\",\"toggle-action\",\"ember-popover\",\"t\",\"link-to-external\",\"html-safe\",\"shared/ui/button\",\"shared/emoji-textarea\",\"concat-classes\",\"on\"]]",
    "moduleName": "shared/components/shared/post/secondary/activity/footer.hbs",
    "isStrictMode": false
  });
  let FooterComponent = _exports.default = (_class = (_maxCharacters = /*#__PURE__*/new WeakMap(), class FooterComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "auth", _descriptor, this);
      _initializerDefineProperty(this, "perfectScroll", _descriptor2, this);
      _initializerDefineProperty(this, "segment", _descriptor3, this);
      _classPrivateFieldInitSpec(this, _maxCharacters, {
        writable: true,
        value: 500
      });
      _initializerDefineProperty(this, "commentContent", _descriptor4, this);
      _initializerDefineProperty(this, "autoFocus", _descriptor5, this);
      _defineProperty(this, "saveComment", (0, _asyncArrowRuntime.buildTask)(() => ({
        context: this,
        generator: function* () {
          this.args.saveComment(this.sanitizedCommentContent);
          this.commentContent = '';
          yield (0, _emberConcurrency.timeout)(200);
          this.perfectScroll.scrollToBottom(this.args.scrollbarId);
        }
      }), null, "saveComment", null));
    }
    get canUsePostActivityLog() {
      return Boolean(this.auth.currentAccount.canUsePostActivityLog);
    }
    get charactersRemaining() {
      return _classPrivateFieldGet(this, _maxCharacters) - this.sanitizedCommentContent.length;
    }
    get exceededCharacterLimit() {
      return this.sanitizedCommentContent.length > _classPrivateFieldGet(this, _maxCharacters);
    }
    get isEmpty() {
      return this.sanitizedCommentContent.length <= 0;
    }
    get isDisabled() {
      return this.exceededCharacterLimit || this.isEmpty;
    }
    get showLargeText() {
      return (0, _lodash.toArray)(this.commentContent).length <= 3 && (0, _isEmojiOnly.default)(this.commentContent);
    }
    get username() {
      return this.auth.currentUserModel.name || this.auth.currentUserModel.email;
    }
    get needsUsernameUpdate() {
      const {
        email,
        name
      } = this.auth.currentUserModel;
      return email === name || (0, _utils.isEmpty)(this.username);
    }
    get sanitizedCommentContent() {
      return this.commentContent.trim();
    }
    trackPopoverClicked() {
      this.segment.track(_segmentEvents.SegmentEventTypes.ClickedNameTooltip);
    }
    onKeyUp(event) {
      if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
        event.stopPropagation();
      }
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "auth", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "perfectScroll", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "segment", [_service.service], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "commentContent", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return '';
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "autoFocus", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "trackPopoverClicked", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "trackPopoverClicked"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onKeyUp", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onKeyUp"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, FooterComponent);
});